import { Grid, Typography } from '@mui/material'
import React from 'react'

const WelcomeHeader = ({ header }) => {
    const { header_title = [] } = header || {};
    return (
      <Grid container sx={{ p:5 }}>
        {header_title.map((item, index) => (
          <Typography
            key={index}
            variant="h4"
            sx={{
              color: item?.color,
              fontWeight: item?.fontWeight,
              display: item?.addBreak ? 'block' : 'inline',
              fontSize: ['1.5rem', '1.5rem', '1.8rem', '2.2rem'],
            }}
          >
            {item?.text}
            {item?.addBreak ? <br/> :  <span>&nbsp;</span>}
          </Typography>
        ))}
    </Grid>
    );
};

export default WelcomeHeader